export function arrayToTypes(array: any, valueAttribute: string, labelAttribute: string) {
    const inputArray = array.map((item: any) => {
        return {
            label: item[labelAttribute],
            value: item[valueAttribute]
        }
    })
    return inputArray
}
